import { render } from "./Wallet.vue?vue&type=template&id=77c1838e&scoped=true"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"

import "./Wallet.vue?vue&type=style&index=0&id=77c1838e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-77c1838e"

export default script